import React, { useCallback, Fragment } from 'react';
import { isEqual } from 'lodash'
import { updateEmptyEntity, setEditorView } from 'actions/livefeed';
import { setLivefeedOptions } from 'actions/livefeed/livefeedOptions'

import LogoContainer from './entity/LogoContainer';
import LineContainer from './entity/LineContainer'
import TextContainer from './entity/TextContainer'
import LocationsList from './entity/LocationsList'
import { livefeedStyle } from 'components/pages/livefeed/defaultstate'
import Widgets from './Widgets'
import SteerPathMap from './Floorplan/SteerPathMap'
import './summary.less'

export default ({
    scaleMode, dispatch, livefeedSlides, slideCurrentIndex, nodeMap, stepNumberState, editorView,
    sensorMap, mapConfigMode, handleOpenLocationModal, focusMapApiInput }) => {
    const { textContainer, slideType, floorplanOptions: { locationsID } } = livefeedSlides[slideCurrentIndex]
    let refinedLocationsID = []
    if (locationsID) {
        refinedLocationsID = locationsID.filter(id => nodeMap[id])
    }
    return (
        <Fragment>
            <LogoContainer
                editorView={editorView}
                scaleMode={scaleMode}
                dispatch={dispatch}
                stepNumberState={stepNumberState}
                slideCurrentIndex={slideCurrentIndex}
                livefeedSlides={livefeedSlides}
            />
            <LineContainer
                editorView={editorView}
                scaleMode={scaleMode}
                dispatch={dispatch}
                stepNumberState={stepNumberState}
                slideCurrentIndex={slideCurrentIndex}
                livefeedSlides={livefeedSlides}
            />
            {textContainer.length > 0 &&
                <TextContainer
                    editorView={editorView}
                    scaleMode={scaleMode}
                    dispatch={dispatch}
                    stepNumberState={stepNumberState}
                    slideCurrentIndex={slideCurrentIndex}
                    livefeedSlides={livefeedSlides}
                />
            }
            {slideType === "locationsList" &&
                <LocationsList scaleMode={scaleMode} />
            }
            {slideType === "summary" &&
                <Fragment>
                    <Widgets
                        dispatch={dispatch}
                        scaleMode={scaleMode}
                        livefeedSlides={livefeedSlides}
                        slideCurrentIndex={slideCurrentIndex}
                        sensorMap={sensorMap}
                        nodeMap={nodeMap}
                        editorView={editorView}
                        stepNumberState={stepNumberState}
                    />
                    {!refinedLocationsID.length > 0 &&
                        <div className="summary-location" onClick={handleOpenLocationModal}>
                            Choose locations to be displayed on slide show
                        </div>
                    }
                </Fragment>
            }
            <LeftPanelContainer
                scaleMode={scaleMode}
                nodeMap={nodeMap}
                sensorMap={sensorMap}
                livefeedSlide={livefeedSlides[slideCurrentIndex]}
                handleOpenLocationModal={handleOpenLocationModal}
                focusMapApiInput={focusMapApiInput}
                mapConfigMode={mapConfigMode}
                editorView={editorView}
                stepNumberState={stepNumberState}
                dispatch={dispatch}
                slideCurrentIndex={slideCurrentIndex}
            />
        </Fragment>
    )
}

const LeftPanelContainer = ({
    scaleMode, dispatch, mapConfigMode, focusMapApiInput, livefeedSlide, editorView,
    stepNumberState, slideCurrentIndex, nodeMap, handleOpenLocationModal }) => {

    const { slideBg, leftPanelBg, floorplanOptions: { locationsID } = {}, fontFamily,
        historyEntities, slideType } = livefeedSlide

    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];

    const removeCurrentEntitty = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        let emptyEntity = { id: null, fontFamily: fontFamily } // Prevent duplicate dispatch
        isEqual(emptyEntity, currentEntity) === false && (
            dispatch(updateEmptyEntity())
        )
    }, [currentEntity, dispatch, fontFamily])

    const handleRightClick = useCallback((e) => {
        e.stopPropagation(); e.preventDefault();
        dispatch(setEditorView(!editorView))
        removeCurrentEntitty(e)
    }, [dispatch, editorView, removeCurrentEntitty])

    // single option
    const setLivefeedOptionsHandle = useCallback((type, value) => {
        dispatch(setLivefeedOptions(type, value))
    }, [dispatch])

    function renderFloorplan() {
        if (slideType !== "summary" && slideType !== "locationsList") {
            const { floorplanOptions: { mapApiKey, liveApiKey, mapConfig } } = livefeedSlide
            let refinedLocationsID = []
            if (locationsID) {
                refinedLocationsID = locationsID.filter(id => nodeMap[id])
            }
            return (
                <div className="floorplan-preview"
                    style={{
                        top: 126 * (scaleMode ? 0.375 : 1),
                        bottom: 33 * (scaleMode ? 0.375 : 1),
                        left: 33 * (scaleMode ? 0.375 : 1),
                        right: 33 * (scaleMode ? 0.375 : 1),
                    }}>
                    {mapApiKey ?
                        !scaleMode ?
                            <SteerPathMap
                                dispatch={dispatch}
                                setLivefeedOptionsHandle={setLivefeedOptionsHandle}
                                mapApiKey={mapApiKey}
                                liveApiKey={liveApiKey}
                                mapConfigMode={mapConfigMode}
                                mapConfig={mapConfig}
                                slideCurrentIndex={slideCurrentIndex}
                            />
                            :
                            <div className="map-placeholder" style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#9b9b9b'
                            }} />
                        :
                        <React.Fragment>
                            {/* Only display if senzolive locations have been chosen */}
                            {
                                (refinedLocationsID && (refinedLocationsID.length > 0)) &&
                                <div style={{ fontSize: 20 * (scaleMode ? 0.375 : 1) }} onClick={focusMapApiInput}
                                    className="floorplan-info">
                                    Please set map API key first
                                </div>
                            }
                        </React.Fragment>
                    }
                    <div className="floorplan-info"
                        style={{
                            fontSize: 20 * (scaleMode ? 0.375 : 1),
                        }}
                        onClick={handleOpenLocationModal}
                    >
                        {refinedLocationsID && (!refinedLocationsID.length > 0 && "No chosen senzolive locations. Click to choose locations")}
                    </div>
                </div>
            )
        }
    }
    return (
        <React.Fragment>
            <div className="pane left"
                onClick={(e) => !scaleMode ? removeCurrentEntitty(e) : null}
                onContextMenu={(e) => process.env.NODE_ENV === 'production' && !scaleMode && handleRightClick(e)}
                style={{
                    zIndex: 0,
                    width: (slideType === "summary" || slideType === "locationsList") ? "100%" : livefeedStyle.leftPaneWidth + "%",
                    backgroundColor: (slideType === "summary" || slideType === "locationsList") ? slideBg.color : leftPanelBg.color
                }}>
                {renderFloorplan()}
            </div >
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/index.jsx